export default "<div class=\"maclass\">\r\n    <amplify-authenticator> </amplify-authenticator>\r\n</div>\r\n\r\n"